export class Globals {
  static readonly APP_NAME = "Kliq pro";
  static readonly MIN_CONFIGURATOR_SIZE = 1024;
  static readonly IS_DEBUG = false;
  static readonly IS_PROD_ENV = process.env.NODE_ENV === "production";
  static readonly INSOLE_MODEL_FILE_EXTENSION = ".stl";
  // Triangle budget for the lightweight working/edit mesh (server decimation +
  // runtime fallback). The full-res original is always used for export.
  static readonly WORKING_MESH_TRIANGLE_BUDGET = 180000;
  // Minimum material thickness (mm) kept between the plantar surface and the
  // ground, so a deep offloading/recess never pierces the insole. Keeps the
  // exported mesh printable and structurally sound.
  static readonly MIN_INSOLE_THICKNESS_MM = 1.5;
}
